import { observer } from 'mobx-react-lite';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { useStore } from '@hooks/useStore';
import { AppLoader } from '@components/Core/AppLoader';
import { PageHeader } from '@components/Core/PageHeader';
import BrandTabs from '@components/Core/BrandTabs';
import BrandForm from '@forms/BrandForm';

function EditBrand() {
  const {
    brandsStore: { brand },
  } = useStore();

  const { isFetching, text } = useGetBrandData();

  return (
    <div className="page-container">
      <PageHeader text={text} />
      <BrandTabs currentTab="edit" />
      {isFetching && <AppLoader />}
      {!isFetching && brand && <BrandForm brand={brand} />}
    </div>
  );
}

export default observer(EditBrand);
